import { menu_query_button_systemId_get } from 'server/modules/351.js'
const getDefaultState = () => {
  return {
    isFreshMenus: false,
    btnPermission: null,
    otherSystemId: null,
    otherSystemName: null,
    otherMenuName: null
  }
}
const state = getDefaultState()

const mutations = {
  // 是否刷新菜单
  SET_FRESHMENUS: (state, flag) => {
    state.isFreshMenus = flag
  },
  SET_OTHER_SYSTEM: (state, { id, name, menuName }) => {
    state.otherSystemId = id
    state.otherSystemName = name
    state.otherMenuName = menuName
    localStorage.setItem('otherSystemId', id)
  },
  // 设置页面按钮权限
  SET_BTN_PERMISSION(state, obj) {
    state.btnPermission = obj
    sessionStorage.setItem('permission_button', JSON.stringify(obj))
  },
  SET_RESETSTATE(state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  // actions一般是处理异步逻辑
  // 根据系统id获取按钮列表
  async GET_USER_PERMISSION({ commit, state }) {
    const result = await menu_query_button_systemId_get({
      systemId: state.otherSystemId
    }).catch(e => {
      console.log(e)
    })
    if (result && result.success) {
      const { data } = result
      commit('SET_BTN_PERMISSION', data)
    }
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
